import Checkbox from '@components/common/Checkbox';
import { Typography } from '@components/common/Typography';
import styled from 'styled-components';

export const Container = styled.label`
  display: flex;
  width: 100%;
  margin-bottom: 24px;
`;

export const CheckboxContainer = styled.div`
  padding-top: 5px;
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-right: 8px;
`;

export const QuestionText = styled(Typography)`
  display: block;
  font-family: ${({ theme }) => theme.fonts.archivo};
  color: ${({ theme }) => theme.colors.functional.gray8};
`;

export const BalanceText = styled(QuestionText)`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.functional.darkGray};
  font-weight: 400;
`;
